module.exports = __webpack_public_path__ + "img/b1d4342.png";